import React from 'react';
import { Clock, ShieldAlert, CheckCircle, Brain, Lock, Plug } from 'lucide-react';
export function FeaturesGrid() {
  const features = [{
    icon: Clock,
    title: 'Save Hours Every Week',
    description: 'Stop manually matching transactions. Berry reconciles in minutes what used to take hours of tedious work.'
  }, {
    icon: ShieldAlert,
    title: 'Catch Every Anomaly',
    description: 'AI-powered anomaly detection flags suspicious transactions and duplicates before they become problems.'
  }, {
    icon: CheckCircle,
    title: 'Eliminate Errors',
    description: "Reduce human error with automated matching that's 99.7% accurate. Say goodbye to spreadsheet typos."
  }, {
    icon: Brain,
    title: 'Smart Transaction Matching',
    description: 'Intelligent algorithms learn your specific business patterns for increasingly accurate reconciliation over time.'
  }, {
    icon: Lock,
    title: 'Bank-Level Security',
    description: 'Your financial data is encrypted end-to-end with SOC 2 compliance. We take security as seriously as you do.'
  }, {
    icon: Plug,
    title: 'Works With Your Tools',
    description: 'Seamlessly integrates with QuickBooks, Xero, FreshBooks, and connects to over 10,000 financial institutions.'
  }];
  return <section id="features" className="py-24 bg-white" data-id="element-124">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-125">
        <div className="text-center mb-20" data-id="element-126">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-127">
            Why small businesses love Berry
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-128">
            Everything you need to keep your books balanced and your business
            growing.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12" data-id="element-129">
          {features.map((feature, index) => <div key={index} className="flex flex-col items-start p-6 rounded-2xl hover:bg-gray-50 transition-colors duration-300" data-id="element-130">

              <div className="w-12 h-12 rounded-lg bg-violet-100 flex items-center justify-center mb-6 text-violet-600" data-id="element-131">
                <feature.icon className="h-6 w-6" data-id="element-132" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-133">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-134">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}